import { useEffect, useState } from 'react';
import StockDetailsTable from '../../components/tables/StockDetailsTable';
import {
  DUMMY_STOCKS,
  DUMMY_STOCKS_ON_HAND,
} from '../../dummy_data/Dummy_Stock';
import { Stock, StockOnHand } from '../../models/stock';
import { TabItem } from '../../models/common';
import Tabs from '../../components/tabs/Tabs';
import HeldStocksTable from '../../components/tables/HeldStocksTable';

enum TabName {
  AVAILABLE_STOCKS = 'Available Stocks',
  HELDSTOCKS = 'Held Stocks',
}

const DefaultTabItemsOptions: TabItem[] = [
  { name: TabName.AVAILABLE_STOCKS, current: true },
  { name: TabName.HELDSTOCKS, current: false },
];

const StocksPage = () => {
  const [stocks, setStocks] = useState<Stock[] | null>(null);
  const [heldStocks, setHeldStocks] = useState<StockOnHand[] | null>(null);
  const [tabItems, setTabsItem] = useState<TabItem[]>(DefaultTabItemsOptions);

  const onClickTab = (tabName: string) => {
    const tempOptions = [...tabItems];
    tempOptions.forEach((tab, idx) => {
      if (tab.name === tabName) {
        tempOptions[idx].current = true;
      } else {
        tempOptions[idx].current = false;
      }
    });

    setTabsItem(tempOptions);
  };

  useEffect(() => {
    setStocks(DUMMY_STOCKS);
    setHeldStocks(
      DUMMY_STOCKS_ON_HAND.sort((s1, s2) => (s1.ticker > s2.ticker ? 1 : -1))
    );
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-8">
      <div className="sm:flex sm:items-center">
        <Tabs tabItems={tabItems} onChangeTab={onClickTab}></Tabs>
      </div>

      {tabItems.find((t) => t.name === TabName.AVAILABLE_STOCKS)?.current &&
        stocks && <StockDetailsTable stocks={stocks}></StockDetailsTable>}
      {tabItems.find((t) => t.name === TabName.HELDSTOCKS)?.current &&
        heldStocks && (
          <HeldStocksTable heldStocks={heldStocks}></HeldStocksTable>
        )}
    </div>
  );
};

export default StocksPage;
